<div class="options-container" [formGroup]="filterselectorFormGroup">
  <app-searchable-multi-select-filter class="left" name="filters" [label]="'Filter' | translate"
    [getData]="getPagedFilters" [changeCallback]="changeFilters" [showAllIfSearchIsEmpty]="true"
    [pageSize]="filters?.length"></app-searchable-multi-select-filter>
  @if (showFilterPresetSelector$ | async) {
  <mat-form-field appearance="outline" class="filter-preset-selector">
    <mat-label>Filtr</mat-label>
    <mat-select [value]="selectedPresetId$ | async" (valueChange)="setActiveFilterPreset($event)">
      @for (preset of presets$ | async; track preset) {
      <mat-option [value]="preset.Id">{{
        preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  <div class="favorite-button-row-container">
    @if (isSavedFilterPreset$ | async) {
    <button (click)="unsaveFilterPresetButtonClick()" class="favorite-button">
      <mat-icon>bookmark</mat-icon>
      @if (screenService.isAboveMd$ | async) {
      {{ 'UnsaveFilter' | translate }}
      }
    </button>
    } @else {
    <button (click)="saveFilterPresetButtonClick()" class="favorite-button"
      [disabled]="(selectedPresetId$ | async) === undefined">
      <mat-icon>bookmark_border</mat-icon>
      @if (screenService.isAboveMd$ | async) {
      {{ 'SaveFilter' | translate }}
      }
    </button>
    }
  </div>
</div>

<div class="filters-container" [formGroup]="formGroup">
  @for (filter of enabledFilters; track filter) {
  <div>
    @switch (filter.type) {
    @case (FilterType.Autocomplete) {
    <app-autocomplete-filter [name]="filter.name" [label]="filter.label" [placeholder]="filter.placeholder"
      [datasource]="filter.datasource$ | async" [changeCallback]="filter.changeCallback"
      [searchTextChangeCallback]="filter.searchTextChangeCallback"
      [description]="filter.description"></app-autocomplete-filter>
    }
    @case (FilterType.Text) {
    <app-text-filter [name]="filter.name" [label]="filter.label" [placeholder]="filter.placeholder"
      [changeCallback]="filter.changeCallback" [description]="filter.description"></app-text-filter>
    }
    @case (FilterType.Select) {
    <app-select-filter [name]="filter.name" [label]="filter.label" [placeholder]="filter.placeholder"
      [multiple]="filter.multiple" [datasource]="filter.datasource$ | async" [changeCallback]="filter.changeCallback"
      [description]="filter.description"></app-select-filter>
    }
    @case (FilterType.SearchableMultiselect) {
    <app-searchable-multi-select-filter [name]="filter.name" [label]="filter.label" [placeholder]="filter.placeholder"
      [getData]="filter.getData" [changeCallback]="filter.changeCallback"
      [description]="filter.description"></app-searchable-multi-select-filter>
    }
    @case (FilterType.Date) {
    <app-date-filter [name]="filter.name" [label]="filter.label" [placeholder]="filter.placeholder"
      [changeCallback]="filter.changeCallback" [description]="filter.description"></app-date-filter>
    }
    @case (FilterType.ReadonlyInlineListFilter) {
    <app-readonly-inline-list-filter [name]="filter.name" [label]="filter.label" [placeholder]="filter.placeholder"
      [datasource]="filter.datasource$ | async" [description]="filter.description"></app-readonly-inline-list-filter>
    }
    @case (FilterType.DateRange) {
    <app-date-range-filter [name]="filter.name" [label]="filter.label" [placeholder]="filter.placeholder"
      [changeCallback]="filter.changeCallback" [description]="filter.description"></app-date-range-filter>
    }
    }
  </div>
  }
</div>